/** @format */

import axios from 'axios';
import { keycloakClient } from '../contexts/KeyCloakContext';
import i18n from '../i18n';
import { resolveAcceptLanguage } from './acceptLanguage';

const { REACT_APP_API_URL } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_API_URL
});

axiosInstance.interceptors.request.use(
  async config => {
    const newConfigs = { ...config };
    if (keycloakClient.token) {
      const isTokenExpired = await keycloakClient.isTokenExpired();
      if (isTokenExpired) {
        await keycloakClient.updateToken().catch(error => {
          console.error(error);
        });
        axiosInstance.defaults.headers.common.Authorization = `Bearer ${keycloakClient.token}`;
        newConfigs.headers.common = { ...config.headers.common, Authorization: `Bearer ${keycloakClient.token}` };
      }
    }
    newConfigs.headers.set('Accept-Language', resolveAcceptLanguage(i18n, keycloakClient));
    return newConfigs;
  },
  error => {
    return Promise.reject('Something went wrong');
  }
);

axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
